<template>
  <div id="tiposobra-toolbar-tiposobra">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Tipos de Obra
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarTiposObra',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
